import { RouterView } from "vue-router";

export const couponsRoute = {
  path: ":menu/coupons",
  component: <RouterView />,
  children: [
    {
      path: "",
      component: () => import("@/views/coupons/list/index.vue"),
    },
  ],
};
